import { render, staticRenderFns } from "./AccountDialog.vue?vue&type=template&id=79afe4ff&scoped=true"
import script from "./AccountDialog.vue?vue&type=script&lang=js"
export * from "./AccountDialog.vue?vue&type=script&lang=js"
import style0 from "./AccountDialog.vue?vue&type=style&index=0&id=79afe4ff&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79afe4ff",
  null
  
)

export default component.exports